import {useContext} from 'react';
import Box from '@mui/material/Box';
import Statistics from '../../components/Charts/statistics/Statistics';
import DoctorExpensesLineChart from '../../components/Charts/line/DoctorExpensesLineChart';
// import StateChart from '../../components/Charts/pie/StateChart';
import State from '../../components/Charts/piev2/State';
import useInsuranceAnalysisData from '../InsuranceAnalysisPage/useInsuranceAnalysisData';

// Icons
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AppContext from '../../contexts/app-context';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SavingsIcon from '@mui/icons-material/Savings';
import { statsTitles } from '../../components/config/variables';

const AnalysisPage = () => {
  const appCtx = useContext(AppContext)
  const userRole = appCtx.userRole
  const type = userRole === 'facility_admin' ? 'weekly' : 'med_cost'
  const { statsData } = useInsuranceAnalysisData(type);

  const icons = {
    total_expenditure: (
        <AttachMoneyIcon fontSize="small" sx={{color: '#fff'}} />
    ),
    approved_ratio: (
        <CheckCircleIcon fontSize="small" sx={{color: '#fff'}} />
    ),
    total_encounters: (
        <EventAvailableIcon fontSize="small" sx={{color: '#fff'}} />
    ),
    avg_cost: (
        <RequestQuoteIcon fontSize="small" sx={{color: '#fff'}} />
    ),
    top_drug: (
      <CalendarTodayIcon fontSize="small" sx={{ color: '#fff' }} />
    ),
    money_saved: (
      <SavingsIcon fontSize="small" sx={{ color: '#fff' }} />
    ),
  };

  const symbol = {
    total_expenditure: '$',
    approved_ratio: '%',
    total_encounters: '',
    avg_cost: '$',
    money_saved: '$',
  };

  return (
    <>
      <Statistics 
        data={statsData}
        cards={userRole === 'facility_admin'
          ? ['total_expenditure', 'approved_ratio', 'total_encounters', 'avg_cost']
          : ['total_expenditure', 'avg_cost', 'money_saved', 'top_drug']
        }
        titles={statsTitles} icons={icons} symbol={symbol} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          border: '1px solid #d9d9d9',
          borderRadius: '10px',
          padding: '10px 0'
        }}
      >
        <Box sx={{ width: '68%' }}>
          <DoctorExpensesLineChart />
        </Box>
        <Box sx={{ width: '32%' }}>
          <State />
        </Box>
      </Box>
    </>
  );
};

export default AnalysisPage;